import { Card, CardBody, CardHeader, Button, Label } from "reactstrap";
import { ACCOUNT_TYPES, BANKS } from "../../utils/bankConstants";

export const CardUserBankAccount = ({ user }) => {

  return (
    <Card>
      <CardHeader>Información bancaria</CardHeader>
      <CardBody>
        {/* 🔹 Información bancaria */}
        {user.bankAccount ? (
          <>
            <p>
              <strong>Titular:</strong>{" "}
              {user.bankAccount.accountHolderName}
            </p>

            <p>
              <strong>Tipo de identificación:</strong>{" "}
              {user.bankAccount.identificationType}
            </p>

            <p>
              <strong>Número de identificación:</strong>{" "}
              {user.bankAccount.identificationNumber}
            </p>

            <p>
              <strong>Código del banco:</strong>{" "}
              {BANKS.find(bank => bank.id === user.bankAccount.bankCode)?.name}
            </p>

            <p>
              <strong>Tipo de cuenta:</strong>{" "}
              {ACCOUNT_TYPES.find(type => type.id === user.bankAccount.accountType)?.label}
            </p>

            <p>
              <strong>
                {user.bankAccount.accountType === 4
                  ? "Número de celular"
                  : user.bankAccount.accountType === 5
                  ? "Llave"
                  : "Número de cuenta"}
                :
              </strong>{" "}
              {user.bankAccount.accountNumber}
            </p>

            <p>
              <strong>Aceptó términos:</strong>{" "}
              {user.bankAccount.acceptedTerms ? "Sí" : "No"}
            </p>
          </>
        ):<p>No hay informacion</p>}
      </CardBody>
    </Card>
  );
};